import { GraphQLError } from "graphql"
import { groq } from "next-sanity"
import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"
import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryDownloadCenter = {
  async downloadCenter(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user, sanityClient } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.DOWNLOAD_CENTER,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    sanityClient.config({ ...config, useCdn: cdn })

    const { draftsFilter } = groqQueryOptions({ includeDrafts: true })

    // Fetch available download center documents
    // Sort by sortOrder and categoryTitle
    let sanityData = []

    try {
      sanityData = await sanityClient.fetch(
        groq`*[_type=="downloadCenter" && count(attachments) > 0 ${draftsFilter}] | order(coalesce(sortOrder, 999999) asc, lower(categoryTitle) asc){
        "id": _id,
        sortOrder,
        categoryTitle,
        attachments[]{
          label,
          file{
            asset->{url, originalFilename}
          }
        }
      }`,
      )
    } catch (error) {
      console.error("queryDownloadCenter() - Sanity fetch failed", { error })
      throw new GraphQLError("Failed to fetch download center documents from Sanity", {
        extensions: { code: "SANITY_FETCH_ERROR" },
      })
    }

    return sanityData
  },
}
